import * as React from 'react';
import { ConfigAndDataContext } from '@/state/context/ConfigAndDataContext';
import Toast from '../../objects/Toast';
import { useContext, useEffect, useState } from 'react';
import ExportSettingsDialog from '@/components/avgrensning/shared/ExportSettingsDialog';
import { useVegnettUrls } from '@/utils/exportUtils';
import { ApiVersion } from '@/state';
import { getApiVersion } from '@/utils/Utils';
import { useSelector } from 'react-redux';
import { statePreferences } from '@/selectors/selectors';

export const DownloadResultsBox = () => {
    const { restapi_url, restapi_url_v3, eksport_url, eksport_x_url } =
        useContext(ConfigAndDataContext).config;
    const apiVersion = getApiVersion();
    const rest_api_url = apiVersion === ApiVersion.V3 ? restapi_url_v3 : restapi_url;
    const eksportUrl =
        apiVersion === ApiVersion.V4 && eksport_x_url ? eksport_x_url : eksport_url;
    const eksportApiUrl =
        apiVersion === ApiVersion.V4 && eksport_x_url ? null : rest_api_url;
    const { json, csv } = useVegnettUrls(rest_api_url, eksportUrl, eksportApiUrl);
    const [downloading, setDownloading] = useState(false);

    const [exportDialogOpen, setExportDialogOpen] = useState(false);

    const preferences = useSelector(statePreferences);

    useEffect(() => {
        if (!downloading) return;
        const timeout = setTimeout(() => {
            setDownloading(false);
        }, 5000);
        return () => {
            clearTimeout(timeout);
        };
    }, [downloading]);

    const csvTooltip = () => {
        return `Kartprojeksjon: ${preferences.exportProjection}`;
    };

    const apiTooltip = () => {
        return `Kartprojeksjon: ${preferences.exportProjection}`;
    };

    return (
        <div className="c-results-summary t-hidden-mobile">
            <div className="c-results-summary__export c-results-summary-export">
                <div className="c-results-summary-export__links c-results-summary-export-links t-clearfix">
                    <i
                        className="o-icon-download c-results-summary__icon-download"
                        aria-hidden={true}
                    />
                    <label className="c-results-summary__text">Last ned datasett:</label>
                    <a
                        key="csv-link"
                        className="c-results-summary-export-links__csv"
                        href={csv}
                        onClick={() => setDownloading(true)}
                        title={csvTooltip()}
                    >
                        CSV
                    </a>
                    <a
                        key="api-link"
                        className="c-results-summary-export-links__api"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={json}
                        title={apiTooltip()}
                    >
                        API
                    </a>
                    <button
                        title="Åpne innstillinger for eksport"
                        id="instillinger-link"
                        key="instillinger-link"
                        className="c-results-summary-export-dialog"
                        onClick={() => setExportDialogOpen(true)}
                    >
                        <i
                            className="material-icons"
                            aria-hidden="true"
                            style={{ color: exportDialogOpen ? 'orange' : 'inherit' }}
                        >
                            settings
                        </i>
                    </button>
                </div>
            </div>
            <Toast text={'Nedlasting startet ...'} show={downloading} />
            <ExportSettingsDialog
                isOpen={exportDialogOpen}
                setIsOpen={setExportDialogOpen}
            />
        </div>
    );
};
